import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonInput, INPUT_TYPES } from '@brg/ui';
import { Lang } from '@brg/api';
import { useController, useFormContext } from 'react-hook-form';
import { setProjectTitleByLang } from '../helpers';


interface PropsT {
  isCollectionVote?: boolean;
  disabled?: boolean;
  onChange?: (e: any) => void;
};

const ProjectTitleInput: FC<PropsT> = ({ isCollectionVote, disabled, onChange, ...props }) => {
  const { t, i18n: { language } } = useTranslation();
  const { getValues } = useFormContext();
  const { field: { value, onChange: formOnChange } } = useController({ name: 'title' });
  
  const isBilingual = getValues('isBilingual');
  const additionalContent = getValues('additionalContent');

  const projectTitle = useMemo(() => {
    const title = value || additionalContent?.title;
    return title ? Lang(title, language) : '';
  }, [value, additionalContent, language]);

  const handleChange = (e: any) => {
    const inputValue = e.target.value;
    const newValue = setProjectTitleByLang(isBilingual, value, language, inputValue);
    formOnChange(newValue);
    onChange?.(e);
  };

  const maxLength = useMemo(() => isCollectionVote ? 35 : 75, [isCollectionVote]);

  const placeholder = useMemo(() => {
    const otherLanguageValue = value?.find((item: any) => item.lang !== language)?.name;
    return otherLanguageValue || props?.placeholder || t('project_edit.title_placeholder');
  }, [language, value, props?.placeholder, t]);

  return (
    <CommonInput
      type={INPUT_TYPES.text}
      value={projectTitle || ''}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={maxLength}
      disable={!!disabled}
      {...props}
    />
  );
};

export default ProjectTitleInput;
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonInput, INPUT_TYPES } from '@brg/ui';
import { Lang } from '@brg/api';
import { useController, useFormContext } from 'react-hook-form';
import { setProjectTitleByLang } from '../helpers';


interface PropsT {
  isCollectionVote?: boolean;
  disabled?: boolean;
  onChange?: (e: any) => void;
};

const ProjectTitleInput: FC<PropsT> = ({ isCollectionVote, disabled, onChange, ...props }) => {
  const { t, i18n: { language } } = useTranslation();
  const { getValues } = useFormContext();
  const { field: { value, onChange: formOnChange } } = useController({ name: 'title' });
  
  const isBilingual = getValues('isBilingual');
  const additionalContent = getValues('additionalContent');

  const projectTitle = useMemo(() => {
    const title = value || additionalContent?.title;
    return title ? Lang(title, language) : '';
  }, [value, additionalContent, language]);

  const handleChange = (e: any) => {
    const inputValue = e.target.value;
    const newValue = setProjectTitleByLang(isBilingual, value, language, inputValue);
    formOnChange(newValue);
    onChange?.(e);
  };

  const maxLength = useMemo(() => isCollectionVote ? 35 : 75, [isCollectionVote]);

  const placeholder = useMemo(() => {
    const otherLanguageValue = value?.find((item: any) => item.lang !== language)?.name;
    return otherLanguageValue || props?.placeholder || t('project_edit.title_placeholder');
  }, [language, value, props?.placeholder, t]);

  return (
    <CommonInput
      type={INPUT_TYPES.text}
      value={projectTitle || ''}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={maxLength}
      disable={!!disabled}
      {...props}
    />
  );
};

export default ProjectTitleInput;
